import { render, staticRenderFns } from "./CategoryPromo.vue?vue&type=template&id=5a59161f"
import script from "./CategoryPromo.vue?vue&type=script&lang=js"
export * from "./CategoryPromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports